import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../pageLayout/layout';
import { StyledBulletList } from './magicLinkVerifyError.style';

export const MagicLinkVerifyError = () => {
    return (
        <Layout
            pageId="signin-page"
            heading={
                <FormattedMessage id="auth.magicLink.verify.error.title" />
            }
            showServiceIdentifiers
        >
            <p className="u-margin-bottom">
                <FormattedMessage id="auth.magicLink.verify.error.tryAgain.heading" />
            </p>

            <StyledBulletList>
                <li>
                    <FormattedMessage id="auth.magicLink.verify.error.instruction.backToTv" />
                </li>
                <li>
                    <FormattedMessage id="auth.magicLink.verify.error.instruction.resendEmail" />
                </li>
                <li>
                    <FormattedMessage id="auth.magicLink.verify.error.instruction.openEmail" />
                </li>
            </StyledBulletList>
            <p className="u-margin-top-double">
                <FormattedMessage id="auth.magicLink.verify.error.validityMessage" />
            </p>
        </Layout>
    );
};
